import { createRouter, createWebHashHistory } from 'vue-router'  // 这里修改为createWebHashHistory
import HomeView from '../views/HomeView.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        children: [
            {
                path: '/user',
                name: 'user',
                component: () => import('../views/user/user.vue')
            },
            {
                path: '/cashier',
                name: 'cashier',
                component: () => import('../views/cashier/cashier.vue')
            },
            {
                path: '/online/commodity/classify',
                name: 'onlineclass',
                component: () => import('../views/online_commodity/Classify.vue')
            },
            {
                path: '/online/commodity/products',
                name: 'onlineproducts',
                component: () => import('../views/online_commodity/products.vue')
            },
            {
                path: '/commodity/classify',
                name: 'support',
                component: () => import('../views/commodity/Classify.vue')
            },
            {
                path: '/commodity/products',
                name: 'specification',
                component: () => import('../views/commodity/products.vue')
            },
            {
                path: '/online/commodity/site',
                name: 'site',
                component: () => import('../views/online_commodity/site.vue')
            },
            {
                path: '/banner',
                name: 'banner',
                component: () => import('../views/banner.vue')
            },
            {
                path: '/vip',
                name: 'vip',
                component: () => import('../views/vip.vue')
            },
            {
                path: '/notice',
                name: 'notice',
                component: () => import('../views/notice.vue')
            },
            {
                path: '/coupon',
                name: 'coupon',
                component: () => import('../views/coupon.vue')
            },
            {
                path: '/lottery',
                name: 'lottery',
                component: () => import('../views/lottery.vue')
            },
            {
                path: '/order',
                name: 'order',
                component: () => import('../views/order.vue')
            },
            {
                path: '/agent',
                name: 'agent',
                component: () => import('../views/agent.vue')
            },
            {
                path: '/agentOrder',
                name: 'agentOrder',
                component: () => import('../views/agentOrder.vue')
            },
            {
                path: '/config',
                name: 'config',
                component: () => import('../views/config.vue')
            },
            {
                path: '/homes',
                name: 'homes',
                component: () => import('../views/homes.vue')
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),  // 这里修改为hash模式
    routes
})

export default router
